import React, { useState, useEffect } from "react"
import style from "../components/kunstenaars.module.scss"
import { useStaticQuery, graphql } from "gatsby"
import Bio from "./bio"
import Slideshow from "./slideshow"

export default function Kunstenaars({ tekstCol, row }) {
  const data = useStaticQuery(
    graphql`
      query MyKunstenaars {
        allTekstJson {
          edges {
            node {
              kunstenaars {
                id
                bio
                naam
                web
              }
            }
          }
        }
        allFile(filter: { relativeDirectory: { glob: "slideshow" } }) {
          edges {
            node {
              childImageSharp {
                fluid(maxWidth: 450, quality: 100) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        }
      }
    `
  )

  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(seconds => (seconds + 1) % 7)
    }, 4000)
    return () => clearInterval(interval)
  }, [])

  const kunstenaarlijst = data.allTekstJson.edges[0].node.kunstenaars
  return (
    <div className={style.wrapper} id="kunstenaars" style={{ gridRow: row }}>
      <ul style={{ gridColumn: "7/12" }}>
        {kunstenaarlijst.map((kunstenaar, index) => (
          <Bio
            key={index}
            id={kunstenaar.id}
            naam={kunstenaar.naam}
            bio={kunstenaar.bio}
            link={kunstenaar.web}
          ></Bio>
        ))}
      </ul>
      <Slideshow
        image={data.allFile.edges[seconds].node.childImageSharp.fluid.src}
      ></Slideshow>
    </div>
  )
}
